import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { VideoWrapper } from "~/components/VideoWrapper/VideoWrapper"

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import video from "./assets/video.mp4"
import { Factoids } from "./components/Factoids/Factoids"
import styles from "./index.module.css"

export const Hero: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <VideoWrapper src={video} loop />

      <div className="container">
        <Breadcrumbs />

        <div className="grid grid--col-12">
          <div className={styles.Head}>
            <Heading className={styles.Title} like="h1">
              <Raw html={t("sustainable-development.Hero.Title")} />
            </Heading>

            <div
              dangerouslySetInnerHTML={{ __html: t("sustainable-development.Hero.Description") }}
            />
          </div>
        </div>

        <Factoids className={styles.Factoids} />
      </div>
    </Theme>
  )
}
